import { Suspense } from "react";
import LoadingPage from "views/Base/LoadingPage";
import PermissionRedirect from "./PermissionRedirect";
import { RoutePermission } from "./useRoutePermissions";

interface ElementProps {
  children: React.ReactNode;
  /** `"none"` for routes every authenticated user can see. */
  requiredPermission: RoutePermission;
}

export default function Element(props: ElementProps) {
  const { requiredPermission } = props;
  return (
    <Suspense fallback={<LoadingPage />}>
      <PermissionRedirect requiredPermission={requiredPermission}>
        {props.children}
      </PermissionRedirect>
    </Suspense>
  );
}
